import './CluheadCoversExplore.css';
import { useNavigate } from 'react-router-dom';

export function CluheadCoversExplore() {
   const navigate = useNavigate();

   return (
      <div className="banner cluhead-covers-explore flex flex-1 gap-3">
         <div className="flex flex-col gap-2">
            <h2 className="banner-title">GolfN G Covers</h2>
            <span className="gray-light">Explore available NFTs</span>
         </div>

         <div className={`banner-right-container`}>
            <div
               className="button-border"
               onClick={() => {
                  navigate('/g-covers');
               }}>
               <div className="button">
                  <div className={`button-content`}>
                     <span className="button-text nowrap">Explore</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
